import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors, globals } from '../../styles';
import { SelectProps } from './props';

class StyledSelect extends React.Component<SelectProps, any> {
  render() {
    const {
      children,
      className,
      disabled,
      full,
      onChange,
      name,
      value,
    } = this.props;

    const sanitizedValue = value === null ? undefined : value;

    return (
      <select
        {...this.props}
        className={`${className} ${full ? 'full-width' : ''} ${
          disabled ? 'disabled' : ''
        }`}
        onChange={onChange}
        name={name}
        value={sanitizedValue}
      >
        {children}
      </select>
    );
  }
}

export const Select = styled(StyledSelect)`
  ${globals.button};

  margin-right: 1em;
  padding-left: 1em;
  padding-right: 3em;
  background: ${colors.white};
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAT4AAACICAMAAABJAnfeAAAAM1BMVEUAAAA6PU46PU46PU46PU46PU46PU46PU46PU46PU46PU46PU46PU46PU46PU46PU46PU4Px0RPAAAAEXRSTlMAKEAgCDhggHBQGHhoEDBIWMi82YkAAAN8SURBVHgB7NhHeoYwDITh+bHwgCXK/S+bHqplnqyjd0fZ0D+Bb6/uQ8KjIH3mh2Es25pO+WXo0BS2U/VhFHwqxo0V+EIxHpgAmJRHMzzhpTzJAIxno6AqLLyaMXPTeoCDGG8yKit1RrhKygqwZkE461kFVtmEsJOVdWCdJoRDrzhAT4fwbVY6Vqz0ZMGHsNCVkOgaCsJkdGUAmb4ZiF5x6QRAlJ4YQTr6tOBTUfqsRK80zx4gRp++8F+VgZtmGS9sWKJX7pb2rlEw418eyWL0aYpeeRhpZWRDH73ylCM9G1aJXmn9zouC2Uh+b+++khuGgSCIFpMCo+5/Wt8ACk1vAcvGt7JE4gEzpn/7HIr3W3a9UjgK3wvmeQ2vkDmgW8ozTvYxFr1SPoEpmG2l/i0Lpk8e5P781hVM2SvdOXPPY76kV8qnfQUzn7nv2d8vtok6/f6DUTDj8+zT1XahTdR5pZMlEIxeKaxf8m+iHmShAASjV8hj3/csXuExDxCMXimMIbFgxhffIIaC0Ssks7sfOYPcKeqJbqNeIYJZ5iaL8pG/iPGVKwYegFcUzBQ/G5YFM1/EKwpmXkOPI1Bky+YVBfP8Z0OAGHhOHeQqmGGJ3wHOEwODIFfBlL2y1bHgWfYWi2dlryiYMhr2ml7MWuEJEAS58YIZ9AqKgafEQW68YPQKqOInCHLjX9myN+CV8n0VzF73F9xVLRhSPFMwGwhyFUykV8DYsWDivTI082frc3NeUTDzUplXQAx8pCuexQtGr4AYeEhVPIsXTN+EVxTMUblXQBVfr4A0K2DKGxrwCiiy6RVexU9VPIsXjF4BVfw+X/Es9K28xsq8omDG9cslo4IBRXkFQ7ySQzB6BRTZhvgrnrU2DiCYAK8omGfjXgFLAS6YDXgliWD0CiiyPQOv0KpgsFcUDPeKgtmvdZXu7lTBjMArSQWjV8AvZge/ZOCVVILRK6CKv4EgN41XQJFt0CtMMHoFCkavEHU8Zr1CBaNXymP/RTDHFx+6/0HuRK8omBlMOClH/41gpl+8omC4VxTMDLyiYPTKbzHwk3pFwYyrXgExMPGKgtErJAYmXlEweoX0pIBXFAzxioIhXlEwegXEwMArCkavgCKbXgHjgF5RMHqFFdmYVxQM84qC0SuwyKZXWAzMvKJg9AqMgZlXFIxeYTEw9IqCqdwrf/1y0ONZLYhoAAAAAElFTkSuQmCC');
  background-size: 1em;
  background-position: right 1.25em center;
  background-repeat: no-repeat;

  border: 1px solid ${colors.green500};
  color: ${colors.green500};

  :hover {
    background-color: ${colors.green400};
    border: 1px solid ${colors.green500};
    color: white;
  }
  :focus {
    outline: none;
  }

  &[disabled],
  &.disabled {
    &,
    &:hover {
      background: ${colors.grey10};
      box-shadow: inset 0 0 2px ${colors.grey300};
      color: ${colors.grey300};
      cursor: default;
    }
  }
`;

export default Select;
